<template>
  <a
    href="#"
    @click.prevent="toggleAutoplay"
    @mouseover="showTooltip"
    @mouseleave="hideTooltip"
    data-bs-toggle="tooltip"
    data-bs-placement="top"
    :title="$t('Toggle audio autoplay') + ' (beta)'"
    v-if="compatibleAudioComponents"
  >
    <i
      :class="{
        fas: true,
        'fa-podcast': true,
        'text-success': autoplay,
      }"
    ></i>
  </a>
</template>

<script>
export default {
  methods: {
    showTooltip(event) {
      bootstrap.Tooltip.getOrCreateInstance(event.target).show()
    },
    hideTooltip(event) {
      bootstrap.Tooltip.getOrCreateInstance(event.target).hide()
    },
    toggleAutoplay() {
        this.$store.commit('toggleAudioAutoplay')
    },
  },
  computed: {
      compatibleAudioComponents() {
          if (this.$store.getters.notListenedAudioComponents) {
              return this.$store.getters.notListenedAudioComponents.length
          }
          return false
      },
      autoplay() {
          return this.$store.state.audioAutoplay
      },
  },
}
</script>
